<template>
  <div>
    <div v-if="form">
      <div>
        <p class="bold">Recruiter Name</p>
        <select
          v-model="form.data.recruiter_payment.fields.recruiter_name.value"
        >
          <option v-for="recruiter_name in recruiter_names">
            {{ recruiter_name }}
          </option>
        </select>
      </div>
      <div>
        <p class="bold">Amount</p>
        <input
          type="text"
          v-model="form.data.recruiter_payment.fields.amount.value"
        />
      </div>
      <div>
        <p class="bold">Paid At</p>
        <date-time
          v-model="form.data.recruiter_payment.fields.paid_at.value"
          :date="form.data.recruiter_payment.fields.paid_at.value"
        ></date-time>
      </div>
      <div>
        <p class="bold">Title</p>
        <input
          type="text"
          v-model="form.data.recruiter_payment.fields.title.value"
        />
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations, mapActions } from "vuex";
import DateTime from "@/components/DateTime";
export default {
  name: "recruiter-payment-form",
  props: ["payload"],
  data() {
    return {
      is_loading: false,
      recruiter_names: [],
      form: undefined,
    };
  },
  created() {
    this.$network_utils.getListOfRecruiterNames().then((response) => {
      this.recruiter_names = response.map((i) => i.recruiter_name);
    });
    if (this.payload.is_create) {
      this.setForm({
        id: "",
      });
      return;
    }
    this.$network_utils
      .getRecruiterPayment(this.payload.data.id)
      .then((response) => {
        this.setForm(response);
      });
  },
  methods: {
    setForm(form_data) {
      this.form = new this.$form({
        recruiter_payment: {
          fields: {
            recruiter_name: {
              value: form_data.recruiter_name,
              has_error: false,
              validations: ["Exists"],
            },
            amount: {
              value: form_data.amount,
              has_error: false,
              validations: ["Number", "Exists"],
            },
            paid_at: {
              value: form_data.paid_at || new Date(),
              has_error: false,
              validations: ["Exists"],
            },
            title: {
              value: form_data.title,
              has_error: false,
              validations: [],
            },
          },
          request_details: {
            method: this.payload.is_create ? "post" : "put",
            url: "/recruiter_payments/" + form_data.id,
          },
          is_used: true,
        },
      });
    },
    submit() {
      let response = this.form.mySubmit();
      if (response === false) {
        return;
      }
      this.is_loading = true;
      response.promise
        .then((response) => {
          if (this.payload.callback != undefined) {
            this.payload.callback();
          }
          this.is_loading = false;
          this.removeModal(this.payload);
        })
        .catch(() => {
          this.showToast('ארעה שגיאה')
        });
    },
    ...mapActions('toasts', ['showToast']),
    ...mapMutations("modals", ["removeModal"]),
  },
  components: {
    DateTime,
  },
};
</script>